/*
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-07-19 14:26:53
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-07-20 09:27:45
 * @FilePath: /genetron-web/genetron-h5/src/api/reportQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { get, post } from "@/axios/http";
/** 变异详情页接口 */
const cnvData = data => post('/brave/report/findCnv', data);
const svData = data => post('/brave/report/findSvResult', data);
const snvData = data => post('/brave/report/findSNVResult', data);
/**胚系变异详情接口 */
const embryo = data => post('/brave/report/findGermline', data)
const embryoAll = data => post('/brave/report/findAllGermline', data)
/**胚系变异详情 结果解析 */
const Jiexi = data => post('/brave/report/findInheritanceMutation', data)

/**825 免疫治疗药物提示 */
const myzlData = data => get('/brave/knowledge/findImmunotherapy', data)
const tmbDetails = data => get('/brave/knowledge/findImmuneDetailTmb', data)
const msiDetails = data => get('/brave/knowledge/findImmuneDetailMsi', data)
const getImportantGene = data => post('/brave/important/findKnowledgeImportantGeneModel', data)
const findPrognosis = data => post('/brave/knowledge/prognosis/findPrognosis', data)
const findTargetDrugsCertain = data => post('/brave/knowledge/drugs/findTargetDrugsCertain', data)
const findKnowledgeNoBiomarkerMutation = data => post('/brave/knowledge/noBiomarker/mutation/findKnowledgeNoBiomarkerMutation', data)

// 其他获批药物
const findKnowledgeDrugsNoBiomarker = data => post('/brave/knowledge/drugs/noBiomarker/findKnowledgeDrugsNoBiomarker', data)


/**靶向治疗提示 */
const ByClass = data => post('/brave/knowledge/drugs/findGeneTargetDrugs',
  data)
/**靶向治疗提示获取total接口 */

const ByTotal = data => post('/brave/knowledge/drugs/findGeneTargetDrugsSize',
  data)
// 获取报告日期
const findReportDate = data => post('/brave/knowledge/drugs/findReportDate',
  data)
/**化疗药物提示 */
const hlywData = data => post('/brave/chemotherapy/drugs/findChemotherapy', data)
/**参考文献 */
const Reference = data => get('/brave/knowledgeBase/findReferences', data)
/**获取模版接口 */
const getTemplate = data => get('/brave/report_template/findTemplateByCode', data)
/**ALK 组件接口 */
const getAlk = data => post('/brave/important/findKnowledgeImportantGene',
  data)
/**样本主要质控 */
const getZl = data => post('/brave/qc/findSequencingQc', data)
/**自定义富文本 */
const Quils = data => post('/brave/custom/findModule', data)



export {
  cnvData,
  svData,
  snvData,
  embryo,
  Jiexi,
  myzlData,
  getTemplate,
  ByClass,
  ByTotal,
  hlywData,
  Reference,
  tmbDetails,
  msiDetails,
  embryoAll,
  getAlk,
  getZl,
  Quils,
  getImportantGene,
  findReportDate,
  findPrognosis,
  findKnowledgeDrugsNoBiomarker,
  findTargetDrugsCertain,
  findKnowledgeNoBiomarkerMutation
}